import type { ReckonerEstimate } from "@/store/untested/types"

// Every figure the customer saw, so sales know what the quote was anchored on.
// Rows with no value are dropped.
export function buildReckonerNote(
  estimate: ReckonerEstimate | null | undefined
): string {
  if (!estimate) return ""
  const { panels, batteryKwh } = estimate
  const rows: Array<[string, string | number | null]> = [
    ["Package", estimate.packageLabel],
    ["Solar panels", panels],
    ["Battery", batteryKwh == null ? null : `${batteryKwh} kWh`],
    ["Battery model", estimate.batteryModelLabel],
    ["Installed from", `${estimate.price} inc. VAT`],
    ["Annual savings", estimate.savings],
    ["Payback", estimate.payback],
    ["0% finance from", estimate.monthly],
  ]
  return [
    "[Estimate shown to customer online]",
    ...rows
      .filter(([, value]) => value != null && value !== "")
      .map(([label, value]) => `${label}: ${value}`),
  ].join("\n")
}
